/**
 * Takes a SVG data url and a hexadecimal color value and returns an SVG data url
 * with the `fill` replaced by that color value.
 * @param dataUrl A base64 encoded SVG data url
 * @param color A hexadecimal color value (e.g. #FFFFFF)
 * @return The same SVG with the fill color replaced, encoded as a base64 data url
 */
export function setSvgDataUrlColor(dataUrl: string, color: string): string {
  const parser = new DOMParser()
  const serializer = new XMLSerializer()
  // expecting SVG data url to begin with "data:image/svg+xml;base64, ..."
  const encodedSvg = dataUrl.split(',', 2)[1]
  const decoded = Buffer.from(encodedSvg ?? '', 'base64').toString('utf-8')
  const svg = parser.parseFromString(decoded, 'application/xml')

  svg.getElementsByTagName('svg')[0]?.setAttribute('fill', color)
  const encodedSvgString = Buffer.from(
    serializer.serializeToString(svg),
    'utf-8'
  ).toString('base64')

  return `data:image/svg+xml;base64,${encodedSvgString}`
}
